import { render, staticRenderFns } from "./familias_activas.vue?vue&type=template&id=6a7cc4d7&"
import script from "./familias_activas.vue?vue&type=script&lang=js&"
export * from "./familias_activas.vue?vue&type=script&lang=js&"
import style0 from "./familias_activas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports